import { useEffect } from "react";

const NotificationComponent = ({ data }) => {
    useEffect(() => {
        if (!data) return;

        if (!("Notification" in window)) {
            alert("This browser does not support desktop notifications");
            return;
        }

        const showNotification = async () => {
            if (Notification.permission === "granted") {
                new Notification(data.title, {
                    body: data.body,
                    icon: data.icon,
                    dir: "ltr",
                });
            } else if (Notification.permission !== "denied") {
                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    new Notification(data.title, {
                        body: data.body,
                        icon: data.icon,
                        dir: "ltr",
                    });
                }
            }
        };

        showNotification();
    }, [data]); // ✅ Runs only when `data` changes

    return null;
};

export default NotificationComponent;
